export default __webpack_public_path__ + "static/media/pan-number-gray.c45320f6.svg";